export default __webpack_public_path__ + "static/media/user_blue.43a6dfdb.svg";